export default "__VITE_ASSET__CdQLcnDs__"